import Loader from "./Loader";
import { COLORS, SIZES } from "./utilities";

export { COLORS, SIZES };
export default Loader;
